var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"no-gutters":""}},_vm._l((_vm.userConsents),function(consent,key){return _c('v-col',{key:key,staticClass:"ml-4 pb-1",attrs:{"cols":"12"}},[_c('brand-consent',{attrs:{"brand":key,"consent":consent}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }